import React from 'react';

const containerStyle = {
  textAlign: 'center',
  background: '#ffffff',
  marginBottom: 100,
  borderRadius: 10,
};

const mainContainerStyle = {
  backgroundColor: '#ffffff',
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'space-around',
  alignItems: 'center',
  minHeight: 172,
  paddingTop: 25,
  borderRadius: 7,
};

const cardsContainerStyle = {
  padding: 8,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  borderRadius: 4,
  minWidth: 120,
};

const valueContainerStyle = { marginTop: 18 };

const textStyle = {
  margin: 0,
  marginBottom: 3,
  textAlign: 'center',
  fontSize: 10,
  color: '#000000',
  fontWeight: '500',
};

const textAmtStyle = {
  margin: 0,
  textAlign: 'center',
  fontSize: 18,
  color: '#000000',
  fontWeight: 'normal',
};

export const StatCards = ({ lists, state, title }) => {
  return (
    <div style={containerStyle}>
      <p><h5>{title}</h5></p>
      <div style={mainContainerStyle}>
        {lists.map((l) => (
          <div style={cardsContainerStyle} key={l.id}>
            {l.icon}
            <div style={valueContainerStyle}>
              <p style={textStyle}>{l.title}</p>
              <p style={textAmtStyle}>
                {state ? l.value?.value : (l.value?.value ? '*******' : '')}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export const extra = () => { };
